import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import utils from '../../../../utils/validateScanner.js'
import {
  BasicSelect
} from 'vue-search-select'

export default {
  name: 'shipment-summary',
  mixins: [utils],
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    DatePicker
  },
  props: [],
  data() {
    return {
      pageCountrule: 0,
      pageCount: 0,
      pageNo: 0,
      shippingDetails: {},
      showModal: false,
      isLoadingSearch: false,
      shippingID: '',
      transactions: [],
      shippingIDErrorMSG: '',
      isEmpty: 0,
      pageCountruleBag: 0,
      pageCountBag: 0,
      pageNoBag: 0,
      bagDetails: [],
      showModalBag: false,
      showbagShipmentDetailsModal: false,
      isLoadingSearchBag: false,
      bagNo: '',
      auditLog: [],
      bagShipmentDetails: [],
      showShipmentDetailsTable: true,
      showBagdetailsTable: false,
      shipmentIdError: false,
      bagIdError: false,
      bagIDErrorMSG: '',
      hublist: [],
      openTransitStatus:false,
      TransitStatusData:[],
      groupFlag:false,
			ShowMPSID:false,
      openTransitStatusShipment:false,
      bagSealChangeMessage:'',
      followUpModal: false,
      userHubId: 0,
      createdBy: '',
      ShippingID: '',
      Description: '',
      FollowUpType: '',
      FollowUpTypeID: '',
      FollowUpObjData: {
        value: "",
        text: ""
      },
      FollowUpData: [{
        value: "35",
        text: "(500) - Alternative Instruction awaited From Client"
      }, {
        value: "36",
        text: "(501) - Alternative Instruction For OPS"
      }, {
        value: "37",
        text: "(502) - Operation confirmation Awaited/Followup"
      }, {
        value: "38",
        text: "(503) - Line Haul Delay"
      }, {
        value: "39",
        text: "(504) - RTO"
      }, {
        value: "40",
        text: "(505) - Alternative Instruction For CS"
      }, {
        value: "41",
        text: "(507) - Attempt Delivery"
      }, {
        value: "42",
        text: "(506) - Future Delivery"
      }, {
        value: "43",
        text: "(508) - Alternate Instruction awaited from Security"
      }, {
        value: "44",
        text: "(509) - Alternate Instruction awaited from CST/CLT"
      }, {
        value: "45",
        text: "(510) - Alternate Instruction for Security"
      }, {
        value: "46",
        text: "(511) - Alternate Instruction for CST/CLT"
      }],
      isFollowUpLoading: false,
      todaysDate: new Date(),
      pdddate: '',
      pdddateError: '',
      dateObj: '',
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == undefined || date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
    BagCategory: function(isparentbag) {
      if (isparentbag == true) {
        return "Parent";
      } else if (isparentbag == false) {
        return "Child";
      }
    }
  },
  mounted() {
    let userdetailEncrypt = window.localStorage.getItem('userdetail')
    let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    let userdetail = JSON.parse(plaintext)
    this.userHubId = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0]
    this.createdBy = userdetail[0].email;
    this.getHubList();
  },
  methods: {
    getHubList() {
      this.hublist = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },
    showModalOnClick(shippingDetails) {
      //this.transactions = shippingDetails.Transactions
      var hubDetails = [];
      var logData = [];
      for (var i = 0; i < this.hublist.length; i++) {
        hubDetails[this.hublist[i].value] = this.hublist[i].text;
      }
      if (shippingDetails.Transactions.length > 0) {
        shippingDetails.Transactions.forEach(function(item) {
          item["ProcessLocationName"] = '';
          if (item.ProcessLocation && hubDetails[item.ProcessLocation]) {
            item["ProcessLocationName"] = hubDetails[item.ProcessLocation];
          }
          item["CurrentLocationName"] = '';
          if (item.CurrentLocation && hubDetails[item.CurrentLocation]) {
             item["CurrentLocationName"] = hubDetails[item.CurrentLocation];
          }
          if(item.Latitude && item.Longitude){
            item["Latitude"] = item.Latitude ;
            item["Longitude"] = item.Longitude ;
          }
          // if (item.Latitude && item.Longitude && apiUrl.google_map_flag == true ) {
          //   item["googleMap"] = `https://www.google.com/maps?q=${item.Latitude},${item.Longitude}`;
          // }
          logData.push(item);
        });
      }
      this.transactions = logData;
      this.showModal = true
    },
    closeModal() {
      this.showModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    additionalEnevtLogsPage() {
      this.$router.push({ path: '/AdditionalEventLogs', query: { shippingId: this.shippingID } });

    },
    getBagDetailsByShippingID() {
      if (this.shippingID == '') {
        this.shipmentIdError = true;
        this.shippingIDErrorMSG = 'The Shipping ID field is required.';
        return false;
      } else {
        this.showHideCodeIconInput();
        this.shipmentIdError = false;
        this.shippingIDErrorMSG = '';
        this.isLoadingSearch = true;
        this.input = ({
          "ShippingID": this.shippingID
        })
        axios({
            method: 'POST',
            url: apiUrl.api_url_hubops + 'getShipmentTransactionDetails',
            data: this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoadingSearch = false;
            if (result.data.ResultCode == 100) {
              // PXB-7142 Shipment Color Code & Icon
              if(Object.keys(result.data.lossCategorization).length !=0){
                this.colorCode = result.data.lossCategorization.colorCode;
                this.colorIcon = result.data.lossCategorization.icon;
              }

              this.showShipmentDetailsTable = true;
              this.showBagdetailsTable = false;
              this.shippingDetails = result.data.ResponseData;
              var hubDetails = []
              for (var i = 0; i < this.hublist.length; i++) {
                hubDetails[this.hublist[i].value] = this.hublist[i].text;
              }
              if (this.shippingDetails) {
                this.shippingDetails.OriginHubName = '';
                if (this.shippingDetails.OriginHubID && hubDetails[this.shippingDetails.OriginHubID]) {
                  this.shippingDetails.OriginHubName = hubDetails[this.shippingDetails.OriginHubID];
                }
                this.shippingDetails.CurrentHubName = '';
                if (this.shippingDetails.CurrentHubID && hubDetails[this.shippingDetails.CurrentHubID]) {
                  this.shippingDetails.CurrentHubName = hubDetails[this.shippingDetails.CurrentHubID];
                }
                this.shippingDetails.FinalDestinationName = '';
                if (this.shippingDetails.FinalDestinationID && hubDetails[this.shippingDetails.FinalDestinationID]) {
                  this.shippingDetails.FinalDestinationName = hubDetails[this.shippingDetails.FinalDestinationID];
                }
                this.shippingDetails.RTOHubName = '';
                if (this.shippingDetails.RTOHubId && hubDetails[this.shippingDetails.RTOHubId]) {
                  this.shippingDetails.RTOHubName = hubDetails[this.shippingDetails.RTOHubId];
                }
                this.shippingDetails.Tags = (this.shippingDetails.RTO_DTO_Escalation || this.shippingDetails.FWD_RVP_Escalation) ? 'Escalated' : '';
                this.shippingDetails.PrexoIDAWB = (this.shippingDetails.PrexoID || this.shippingDetails.PrexoReferenceAWB) ? this.shippingDetails.PrexoID +' ('+ this.shippingDetails.PrexoReferenceAWB +')' : '';
              }
              this.isEmpty = Object.keys(this.shippingDetails).length;
              let totalRows = result.data.length
              if (totalRows < 10) {
                this.pageCountrule = 1
              } else {
                this.pageCountrule = Math.ceil(totalRows / 10);
              }
            } else {
              this.showShipmentDetailsTable = true;
              this.showBagdetailsTable = false;
              this.isEmpty = 0;
              this.shippingDetails = [];
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoadingSearch = true;
            console.error(error)
          })
      }
    },
    onSubmitSearch: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        }
        // this.$alertify.success("your message");
      }).catch(() => {
        console.log('errors exist')
        //this.$alertify.error("your message")
      });
    },

    showShipmentDetails() {
			this.ShowMPSID= false ;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getBagShipmentDetailsByBagNumber?bagNo=' + this.bagNo,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingSearchBag = false;
          if (result.data.ResultCode == 100) {
            this.bagShipmentDetails = result.data.ResponseData;
            if(result.data.ResponseData[0].multishipmentgroupid){
							this.ShowMPSID = true
						}
            let totalRows = result.data.ResponseData.length;
            this.showbagShipmentDetailsModal = true;
            if (totalRows < 10) {
              this.pageCountruleBag = 1
            } else {
              this.pageCountruleBag = Math.ceil(totalRows / 10);
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage);
            this.bagShipmentDetails = [];
          }
        }, error => {
          console.error(error)
        })
    },
    closebagShipmentDetailsModal() {
      this.showbagShipmentDetailsModal = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    getBagDetailsByBagNo() {
      this.bagSealChangeMessage = '';
      this.bagDetails = [];
      if (this.bagNo == '' || this.bagNo == undefined) {
        this.bagIdError = true;
        this.bagIDErrorMSG = 'The Bag No field is required.';
        return false;
      } else {
        this.bagIdError = false;
        this.bagIDErrorMSG = '';
        this.isLoadingSearch = true;
        axios({
            method: 'GET',
            url: apiUrl.api_url_hubops + 'getBagDetailsByBagNo?bagno=' + this.bagNo,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.isLoadingSearch = false;
            this.showShipmentDetailsTable = false;
            this.showBagdetailsTable = true;
            if (result.data.ResultCode == 100) {
              if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
                this.colorCodeBag = result.data.lossCategorization.colorCode;
                this.colorIconBag = result.data.lossCategorization.icon;
              }
              this.bagDetails = result.data.ResponseData;
              this.groupFlag =this.bagDetails.BagDetails[0].groupid?true:false;
              //  this.$alertify.success(result.data.ReturnMessage);
              let totalRows = result.data.ResponseData.length
              if (totalRows < 10) {
                this.pageCountruleBag = 1
              } else {
                this.pageCountruleBag = Math.ceil(totalRows / 10);
              }
            } else if (result.data.ResultCode == 111) {
              this.bagSealChangeMessage = result.data.ReturnMessage
  					}else {
              this.$alertify.error(result.data.ReturnMessage);
              this.bagDetails = [];
            }
          }, error => {
            this.isLoadingSearch = false;
            console.error(error)
          })
      }
    },
    showModalOnClickBag(bagDetails) {
      this.auditLog = bagDetails.AuditLog
      this.showModalBag = true
    },
    closeBagModal() {
      this.showModalBag = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    resetForm() {
      this.pageCountrule = 0;
      this.pageCount = 0;
      this.pageNo = 0;
      this.shippingDetails = {};
      this.showModal = false;
      this.isLoadingSearch = false;
      this.shippingID = '';
      this.transactions = [];
      this.shippingIDErrorMSG = '';
      this.isEmpty = 0;


      this.pageCountruleBag = 0;
      this.pageCountBag = 0;
      this.pageNoBag = 0;
      this.bagDetails = [];
      this.showModalBag = false;
      this.showbagShipmentDetailsModal = false;
      this.isLoadingSearchBag = false;
      this.bagNo = '';
      this.auditLog = [];
      this.bagShipmentDetails = [];
      this.showShipmentDetailsTable = true;
      this.showBagdetailsTable = false;
      this.shipmentIdError = false;
      this.bagIdError = false;
      this.bagIDErrorMSG = ''
      this.ShowMPSID=false;
      this.$validator.reset();

      this.showHideCodeIconInput();
    },
    viewTransitStatus()
    {
      this.isLoadingSearch = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'viewTransitStatus?bagNo=' + this.bagNo.trim(),
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            var hubDetails = [];
            var logData = [];
            for (var i = 0; i < this.hublist.length; i++) {
              hubDetails[this.hublist[i].value] = this.hublist[i].text;
            }
            if (result.data.ResponseData.length > 0) {
              result.data.ResponseData.forEach(function(item) {
                item["connectionSourceHubName"] = '';
                if (item.connectionsourcehubid && hubDetails[item.connectionsourcehubid]) {
                  item["connectionSourceHubName"] = hubDetails[item.connectionsourcehubid];
                }
                item["connectionDestinationHubName"] = '';
                if (item.connectiondestinationhubid && hubDetails[item.connectiondestinationhubid]) {
                  item["connectionDestinationHubName"] = hubDetails[item.connectiondestinationhubid];
                }

                logData.push(item);
              });
            }

            this.TransitStatusData = logData;
            this.openTransitStatus = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage);
            this.TransitStatusData = [];
          }
           this.isLoadingSearch = false;
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })

    },


    closeTransitStatus() {
      this.openTransitStatus = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },

    /*HUB-3931 show view transit status for shipment as well*/
    viewTransitStatusShipment()
    {
      var hubDetails = [];
      var logData = [];
      this.isLoadingSearch = true;
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'viewTransitStatus?shippingId=' + this.shippingID,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            for (var i = 0; i < this.hublist.length; i++) {
              hubDetails[this.hublist[i].value] = this.hublist[i].text;
            }

            if (result.data.ResponseData.length > 0) {
              result.data.ResponseData.forEach(function(item) {
                item["connectionSourceHubName"] = '';
                if (item.connectionsourcehubid && hubDetails[item.connectionsourcehubid]) {
                  item["connectionSourceHubName"] = hubDetails[item.connectionsourcehubid];
                }
                item["connectionDestinationHubName"] = '';
                if (item.connectiondestinationhubid && hubDetails[item.connectiondestinationhubid]) {
                  item["connectionDestinationHubName"] = hubDetails[item.connectiondestinationhubid];
                }

                logData.push(item);
              });
            }

            this.TransitStatusData = logData;
            this.openTransitStatusShipment = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage);
            this.TransitStatusData = [];
          }
          this.isLoadingSearch = false;
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })

    },
    closeTransitStatusShipment() {
      this.openTransitStatusShipment = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    closeFollowUpModal() {
      this.followUpModal = false;
      this.resetFields();
    },
    resetFields() {
      this.FollowUpObjData = {
        value: "",
        text: ""
      };
      this.Description = '';
      this.FollowUpType = '';
      this.FollowUpTypeID = '';
      this.pdddate = '';
      this.pdddateError = '';
      this.ShippingID = '';
      this.$validator.reset();
    },
    openFollowUpModal(shippingid) {
      this.ShippingID = shippingid;
      this.followUpModal = true;
      if ((new Date()).getHours() >= 20)
        this.todaysDate.setDate(this.todaysDate.getDate() + 1);
    },
    onSubmit: function () {
      this.$validator.validateAll('followUp').then((result) => {
        if (!result) {
          return false;
        } else {
          this.raiseAWBFollowUpRequest();
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    openFollowUpWindow() {
      this.followUpModal = true;
      if ((new Date()).getHours() >= 20)
        this.todaysDate.setDate(this.todaysDate.getDate() + 1);
      this.ShippingID = '';
      this.$validator.reset();
    },
    clearError() {
      this.pdddateError = '';
    },
    selectedfollowUpType(followUpObjData) {
      this.FollowUpObjData = followUpObjData;
      this.FollowUpType = followUpObjData.text;
      this.FollowUpTypeID = followUpObjData.value;
      this.Description = this.FollowUpType + ' ';
      if (this.pdddate == '' && (this.FollowUpTypeID == 41 || this.FollowUpTypeID == 42)) {
        this.pdddateError = 'Date field is Required';
        this.$refs.pdddate.focus();
        return false;
      } else
        this.pdddateError = '';
    },
    selectedDate() {
      this.pdddateError = '';
      this.dateObj = '';
      if (this.pdddate) {
        this.dateObj = moment(this.pdddate).format('DD-MM-YYYY') + ' ' + String((new Date()).getHours()).padStart(2, '0') + ":" + String((new Date()).getMinutes()).padStart(2, '0') + ":" + String((new Date()).getSeconds()).padStart(2, '0');
        this.Description = this.FollowUpType + ' ' + this.dateObj + ' ';
      }
    },
    raiseAWBFollowUpRequest() {
      if (this.dateObj == '' && (this.FollowUpTypeID == 41 || this.FollowUpTypeID == 42)) {
        this.pdddateError = 'Date field is Required';
        this.$refs.pdddate.focus();
        return false;
      } else
        this.pdddateError = '';
      let shipmentArray = [];
      let format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?~]/;
      if ((format.test(this.ShippingID) == true) ||
        (this.ShippingID[this.ShippingID.trim().length - 1] == ',') ||
        (this.ShippingID.trim()[0] == ',') ||
        this.ShippingID.includes(',,')) {
        this.$alertify.error("Please enter valid AWB's");
        return false;
      }
      if (/\r?\n|\r/g.test(this.ShippingID) == true) {
        this.ShippingID = this.ShippingID.replace(/\r?\n|\r/g, ',');
        if(this.ShippingID[this.ShippingID.trim().length - 1] == ',')
          this.ShippingID[this.ShippingID.trim().length - 1] = '';
      }
      if (/\s/g.test(this.ShippingID) == true) {
        this.ShippingID = this.ShippingID.replace(/\n|"|'| |,\s*$/g, '');
      }
      if (this.ShippingID.indexOf(',') == -1) {
        shipmentArray.push(this.ShippingID);
      } else {
        this.ShippingID.split(',').map(async awb => {
          if(awb) shipmentArray.push(awb);
        });
      }
      if (shipmentArray.length > 50) {
        this.$alertify.error("Please enter maximum 50 AWB's");
        return false;
      }
      this.input = ({
        ShippingID: shipmentArray,
        CurrentHubID: this.userHubId,
        UserProcess: this.FollowUpType,
        CreatedBy: this.createdBy,
        Comments: this.Description,
        ReasonCode: this.FollowUpTypeID
      })
      this.dateObj != '' ? this.input.Date = this.dateObj : '';
      this.isFollowUpLoading = true;
      axios({
        method: 'POST',
        'url': apiUrl.api_url_hubops + 'raiseAWBFollowUpRequest',
        'data': this.input,
        headers: {
          'authorization': 'authkey xB84JJ89Hd25'
        }
      }).then(result => {
        this.isFollowUpLoading = false;
        if (result.data.ResultCode == 100)
          this.$alertify.success(result.data.ReturnMessage);
        else
          this.$alertify.error(result.data.ReturnMessage);
      }, error => {
        this.isFollowUpLoading = false;
        console.error(error)
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BagShipmentQuery/ShipmentBagSummary/ShipmentBagSummary.js